import React, { useEffect, useState } from "react";
import img1 from "../assets/images/gallery/office/img33.webp"
import img2 from "../assets/images/gallery/office/img34.webp"
import img3 from "../assets/images/gallery/office/img47.webp"
import img4 from "../assets/images/gallery/office/img50.webp"
import img5 from "../assets/images/gallery/photography/img3.webp"
import img6 from "../assets/images/gallery/photography/img17.webp"
import img7 from "../assets/images/gallery/travling/img46.webp"
import img8 from "../assets/images/gallery/photography/img15.webp"
import img9 from "../assets/images/gallery/travling/img29.webp"
import img10 from "../assets/images/gallery/photography/img18.webp"
import img11 from "../assets/images/gallery/travling/img30.webp"
import img12 from "../assets/images/gallery/photography/img2.webp"
import StoryCard from "./StoryCard";

const GallerySection = () => {
    const [selectedImg, setSelectedImg] = useState(null);
    useEffect(() => {
        if (selectedImg) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "unset";
    }, [selectedImg]);

    const StoryGallery = [
        {
            id: 1,
            image: img1,
            title: "Stepping Into Growth",
            location: "SRV Media, Pune",
            moment: "Office Visit",
            description:
                "My first visit to the SRV Pune office - a moment of realization that growth begins when comfort zones end.",
            emotion: "Curiosity · Growth · New Beginnings",
            tag: "Career Milestone",
        },
        {
            id: 2,
            image: img2,
            title: "13 Years of Togetherness",
            location: "SRV Media, Pune",
            moment: "Anniversary Celebration",
            description:
                "Celebrating SRV’s 13th anniversary with the team - conversations, smiles, and shared visions for the future.",
            emotion: "Belonging · Gratitude · Team Spirit",
            tag: "Team Culture",
        },
        {
            id: 3,
            image: img3,
            title: "Beyond Work, We Play",
            location: "SRV Media, Kolkata",
            moment: "Cricket Match",
            description:
                "An energetic cricket match at the Kolkata office - bonding beyond screens and deadlines.",
            emotion: "Energy · Bonding · Joy",
            tag: "Work-Life Balance",
        },
        {
            id: 4,
            image: img4,
            title: "Lights, Laughter & Diyas",
            location: "SRV Media, Kolkata",
            moment: "Diwali Celebration",
            description:
                "Diwali at the office - festive lights, shared sweets, and warmth that made the workplace feel like home.",
            emotion: "Celebration · Culture · Warmth",
            tag: "Festive Moments",
        },
        {
            id: 5,
            image: img5,
            title: "Balcony Breaks & City Views",
            location: "Kolkata Office",
            moment: "Photography Break",
            description:
                "A calm balcony break capturing the city skyline - a reminder that small pauses refresh creativity.",
            emotion: "Calm · Observation · Creativity",
            tag: "Everyday Inspiration",
        },
        {
            id: 6,
            image: img6,
            title: "Sunsets & Fresh Minds",
            location: "Office Balcony",
            moment: "Evening Reflection",
            description:
                "Sunset photography from the office balcony - letting the mind breathe after a day of problem-solving.",
            emotion: "Peace · Reset · Mindfulness",
            tag: "Mental Refresh",
        },
        {
            id: 7,
            image: img7,
            title: "Ideas on a Bench",
            location: "Evening Hangout",
            moment: "Deep Discussion",
            description:
                "Casual bench discussions with friends - raw ideas, dreams, and late-evening brainstorming.",
            emotion: "Curiosity · Friendship · Vision",
            tag: "Creative Talks",
        },
        {
            id: 8,
            image: img8,
            title: "Unlocking the Next Level",
            location: "Pune Mountains",
            moment: "Evening Exploration",
            description:
                "An evening on the mountains overlooking the city - every climb unlocking a new level of perspective.",
            emotion: "Freedom · Achievement · Perspective",
            tag: "Personal Growth",
        },
        {
            id: 9,
            image: img9,
            title: "Solo by the Sea",
            location: "Beach",
            moment: "Solo Travel",
            description:
                "Traveling alone by the beach - letting the sound of waves slow my thoughts and reset my mind.",
            emotion: "Peace · Solitude · Healing",
            tag: "Self Reflection",
        },
        {
            id: 10,
            image: img10,
            title: "Nature in Silence",
            location: "Beachside Trees",
            moment: "Photography",
            description:
                "Photographing the beach after trees were cut down - a silent moment that felt heavy and unsettling.",
            emotion: "Sadness · Awareness · Loss",
            tag: "Environmental Thought",
        },
        {
            id: 11,
            image: img11,
            title: "Legacy in Stone",
            location: "Humayun’s Tomb, Delhi",
            moment: "Heritage Visit",
            description:
                "Visiting Humayun’s Tomb - thinking about the creators, their hard work, and the timeless ideas behind this monument.",
            emotion: "Curiosity · Respect · Inspiration",
            tag: "History & Creativity",
        },
        {
            id: 12,
            image: img12,
            title: "Science in Motion",
            location: "Airport",
            moment: "Aviation Photography",
            description:
                "Capturing a flying aeroplane - reflecting on the science, features, and the balance between innovation and its impact.",
            emotion: "Wonder · Logic · Responsibility",
            tag: "Technology & Thought",
        }
    ];



    return (
        <section id="gallery" className="py-24 bg-background-light dark:bg-background-dark border-t border-gray-100 dark:border-gray-800 scroll-mt-20 overflow-hidden">
            <div className="w-[90%] mx-auto">
                <div className="flex flex-col items-center text-center mb-16">
                    <div className="reveal inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary/10 text-primary text-xs font-bold uppercase tracking-widest font-display">
                        <span className="relative flex h-2 w-2">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
                        </span>
                        Life & Inspiration
                    </div>
                    <h2 className="reveal reveal-delay-1 text-4xl md:text-5xl font-bold text-[#0d121b] dark:text-white mt-6 font-display tracking-tight">
                        Moments & Emotions
                    </h2>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {StoryGallery.map((story) => (
                        <StoryCard
                            key={story.id}
                            story={story}
                            onOpen={() => setSelectedImg(story.image)}
                        />
                    ))}
                </div>
            </div>

            {/* --- Fullscreen Lightbox Modal --- */}
            {selectedImg && (
                <div
                    className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4 md:p-10 animate-in fade-in duration-300"
                    onClick={() => setSelectedImg(null)}
                >
                    <button className="absolute top-8 right-8 text-white hover:text-primary transition-colors">
                        <span className="material-symbols-outlined text-4xl">close</span>
                    </button>

                    <img
                        src={selectedImg}
                        className="max-w-full max-h-full rounded-lg shadow-2xl animate-in zoom-in-95 duration-300"
                        alt="Fullscreen view"
                    />
                </div>
            )}
        </section>
    )
}
export default GallerySection;